import { render, staticRenderFns } from "./RegistrationVerify.vue?vue&type=template&id=4b04037a&scoped=true&"
import script from "./RegistrationVerify.vue?vue&type=script&lang=js&"
export * from "./RegistrationVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b04037a",
  null
  
)

export default component.exports